// মেমো প্রিন্টের পেজ সাইজ (ইঞ্চি) — preset + custom, localStorage-এ সংরক্ষিত।
const A4_W_IN = 8.2677; // 210mm — মেমো ডিজাইনের মূল প্রস্থ

export type PrintSize = { key: string; wIn: number; hIn: number };
export type Preset = { key: string; label: string; wIn: number; hIn: number; custom?: boolean };

export const PAGE_PRESETS: Preset[] = [
  { key: "a4", label: "A4 — ৮.৩ × ১১.৭ ইঞ্চি", wIn: 8.2677, hIn: 11.6929 },
  { key: "letter", label: "Letter — ৮.৫ × ১১ ইঞ্চি", wIn: 8.5, hIn: 11 },
  { key: "legal", label: "Legal — ৮.৫ × ১৪ ইঞ্চি", wIn: 8.5, hIn: 14 },
  { key: "a5", label: "A5 — ৫.৮ × ৮.৩ ইঞ্চি", wIn: 5.8268, hIn: 8.2677 },
  { key: "half", label: "হাফ পেজ — ৮.৫ × ৫.৫ ইঞ্চি", wIn: 8.5, hIn: 5.5 },
  { key: "custom", label: "কাস্টম সাইজ (নিজে ইঞ্চি দিন)", wIn: 8.5, hIn: 11, custom: true },
];

const KEY = "rana_print_size_v1";
const DEFAULT: PrintSize = { key: "a4", wIn: 8.2677, hIn: 11.6929 };

export function loadPrintSize(): PrintSize {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (v && typeof v.wIn === "number" && typeof v.hIn === "number" && v.wIn > 0 && v.hIn > 0) return v;
  } catch { /* ignore */ }
  return { ...DEFAULT };
}

export function savePrintSize(v: PrintSize) {
  localStorage.setItem(KEY, JSON.stringify(v));
}

// প্রিন্টের সময় পেজ সাইজ সেট করে ও মেমোকে পেজ-প্রস্থে ফিট করে (zoom)।
export function applyPrintStyle(size: PrintSize) {
  const id = "rana-print-size";
  document.getElementById(id)?.remove();
  const w = Math.max(1, size.wIn);
  const h = Math.max(1, size.hIn);
  const zoom = +(w / A4_W_IN).toFixed(4);
  const css = `@media print { @page { size: ${w}in ${h}in; margin: 0; } .print-area .memo-a4 { zoom: ${zoom}; } }`;
  const el = document.createElement("style");
  el.id = id;
  el.textContent = css;
  document.head.appendChild(el);
}
